module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921135649_T.e46688aa.jpg";